import {
    ChangeDetectionStrategy, ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { INumberFieldSpecs } from 'libraries/module/formbuilder/fields/number/INumberFieldSpecs';

export enum ETdAdditionnalClass{
    inheritReadStyleOnEdition = "inherit-read-style-on-edition"
}

@Component({
    selector: 'td-number-value-editable',
    template: `
        <ng-template #template>
            <td #cell
                class="value-field"
                [ngClass]="additionnalClass"
                [class.light-border]="lightBorder"
                [attr.colspan]="colspan"
                [ngStyle]="style">
                <div class="additional-info cell-header" *ngIf="header">{{header}}</div>
                <number [fieldConfig]="fieldConfig"
                        [disabledStep]="true"
                        [isAlignBottom]="isAlignBottom"
                        [forceFocus]="insideForceFocus"
                        [forceBlur]="forceBlur"
                        [showPlusAndMinus]="false"
                        (onBlur)="blur()"
                        (onKeyUp)="emitKey($event)"></number>
            </td>
        </ng-template>
    `,
    styleUrls: ['td-number-value-editable.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TdNumberValueEditableComponent implements OnInit, OnChanges{
    @Input()
    public fieldConfig: INumberFieldSpecs;
    @Input()
    public forceBlur: boolean;
    @Input()
    public colspan: number = 1;
    @Input()
    public minWidth: string;
    @Input()
    public isSticky: boolean;
    @Input()
    public leftPosition: number;
    @Input()
    public forceFocus: boolean  = true;
    @Input()
    public header: string = null;
    @Input()
    public additionnalClass: ETdAdditionnalClass;
    @Input()
    public lightBorder: boolean = false;
    @Input()
    public isAlignBottom: boolean = false;
    @Input()
    public fixedWidth: string;

    @Output()
    public readonly onBlur: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public readonly onChange: EventEmitter<null> = new EventEmitter<null>();
    @Output()
    public readonly onKeyUp: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild('cell')
    public cell: ElementRef;

    public insideForceFocus: boolean = false;
    public style: { [key: string]: string } = {};

    @ViewChild('template')
    public readonly template: TemplateRef<{}>;

    constructor(
        private readonly viewContainerRef: ViewContainerRef,
        private readonly changeDetector: ChangeDetectorRef
    ) {
    }

    public ngOnInit(): void {
        this.viewContainerRef.createEmbeddedView(this.template);
        if(this.minWidth){
            this.style['min-width'] = this.minWidth;
        }
        if(this.fixedWidth){
            this.style['min-width'] = this.fixedWidth;
            this.style.width = this.fixedWidth;
        }
        setTimeout(() => {
            this.stickCell();
            this.insideForceFocus = this.forceFocus;
            this.changeDetector.detectChanges();
        });
    }

    public ngOnChanges(changes: SimpleChanges): void {
        this.changeDetector.detectChanges();
        if (changes && changes.leftPosition && changes.leftPosition.currentValue && this.style.position && this.style.position === 'sticky') {
            this.style.left = `${changes.leftPosition.currentValue}px`;
            this.style['min-width'] = "unset";
        }
    }

    public blur(): void {
        this.onBlur.emit(false);
    }

    public change(): void {
        this.onChange.emit();
    }

    public emitKey(key: string): void {
        this.onKeyUp.emit(key);
    }

    private stickCell(): void {
        if (this.isSticky && this.cell && this.cell.nativeElement) {
            const left: number = this.cell.nativeElement.offsetLeft - this.cell.nativeElement.parentElement.offsetParent.offsetLeft;
            this.style.left = `${this.leftPosition || left}px`;
            this.style.position = 'sticky';
            this.style['z-index'] = '1';
        }
    }
}
